module.exports = __webpack_public_path__ + "static/media/apply-now.8b605d49.jpg";